import { render, staticRenderFns } from "./DialogHeader.vue?vue&type=template&id=4086e782"
import script from "./DialogHeader.vue?vue&type=script&lang=ts"
export * from "./DialogHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports